import { Button, SxProps, Typography } from "@mui/material";
import Box from "@mui/system/Box";
import { useTranslation } from "react-i18next";
import { ReactComponent as TileNoData } from "src/assets/Icons&UI/tileStates/tileNoData.svg";

const NoDataState = ({
  OnReloadClick,
  icon: Icon,
  text,
  textStyle = { marginTop: "10px" },
  buttonText,
  parentStyle = {}
}: {
  OnReloadClick?: any;
  icon?: any;
  text?: string;
  textStyle?: any;
  buttonText?: string;
  parentStyle?: SxProps;
}) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        ...parentStyle
      }}
      className="noData"
    >
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column"
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            paddingRight: "25px"
          }}
        >
          {Icon ? <Icon /> : <TileNoData />}
          <Typography
            sx={{ letterSpacing: "0.15px", ...textStyle }}
            variant="body1"
            color="grey.900"
          >
            {text ? t(text) : t("noDataAvailable")}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingRight: "25px",
            marginTop: "20px"
          }}
        >
          {OnReloadClick ? (
            <Button
              onClick={OnReloadClick}
              sx={{ color: "primary.main", marginBottom: "10px" }}
            >
              {buttonText ? t(buttonText) : t("reloadData")}
            </Button>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
};

export default NoDataState;
